<template>
  <div>
    <v-tabs v-model="tab"
    flat color="primary" dark
    grow height="40"
    fixed-tabs
    >
    <v-tab v-for="(tabitem, n) in tabitems" :key="n" :href="`#tab-${n}`">
      {{ tabitem }}
    </v-tab>
  </v-tabs>
  <v-container class="pa-1" grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="(tabitem, n) in tabitems" :key="n" :value="`tab-${n}`">
            <v-layout class="pa-1">
              <v-flex xs12 md9 offset-sm3 mx-auto>
                <div v-if="tabitem === 'heads'" class="text-xs-right caption ma-2 grey--text">
                  <v-icon small>lock</v-icon> - System defaults which can not be modified
                </div>
                <div v-else>
                  <v-layout row wrap class="ml-1 mr-1">
                    <v-flex xs9 sm4>
                      <v-select
                      v-model="period"
                      label="Maintenance period"
                      :items="periods"
                      @input="loadHeads()"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-switch
                      v-model="filterBal"
                      label="Filter accounts with opening balance"
                      hide-details
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm8 v-if="tabitem !== 'heads'" mx-auto>
                      <v-layout row wrap :class="'mr-1 subheading white--text ' + (totDebit === totCredit ? 'success' : 'error')">
                        <v-flex xs2 sm4>
                          <strong>Total </strong>
                        </v-flex>
                        <v-flex xs5 sm4>
                          <strong>Debit: {{ handy.formatCur(totDebit) }}</strong>
                        </v-flex>
                        <v-flex xs5 sm4>
                          <strong>Credit: {{ handy.formatCur(totCredit) }}</strong>
                        </v-flex>
                        <v-flex xs12 v-if="totDebit !== totCredit">
                          <div class="text-xs-center">
                            Difference in opening balance {{ handy.formatCur(totDebit - totCredit) }}
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </div>

                <div v-for="(hType, t) in types" :key="t">
                  <v-card class="mb-3" v-if="hType !== 'PERSONAL' || tabitem === 'opening balance'">
                    <v-card-title class="pa-2 grey lighten-4">
                      <div class="title grey--text">{{hType}}</div>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <v-data-table
                      :headers="tabitem === 'heads'?headHead:balHead"
                      :items="heads[hType]"
                      hide-actions
                      disable-initial-sort
                      hide-actions
                      >
                      <template slot="items" slot-scope="props">
                        <tr v-if="!filterBal || props.item.opening_debit || props.item.opening_credit" @click="tabitem !== 'heads' ? prepareUpdateBal(props.item) : !props.item.is_system_acc ? prepareUpdate(props.item) : ''">
                          <td>{{ props.item.gl_acc_name }}</td>
                          <td v-if="tabitem === 'heads'"><v-icon small v-if="props.item.is_system_acc">lock</v-icon></td>
                          <td v-if="tabitem !== 'heads'" class="text-xs-right">{{ (props.item.opening_debit ? handy.formatCur(props.item.opening_debit) : props.item.opening_debit) }}</td>
                          <td v-if="tabitem !== 'heads'" class="text-xs-right">{{ (props.item.opening_credit ? handy.formatCur(props.item.opening_credit) : props.item.opening_credit) }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </div>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-btn v-if="tab === 'tab-0'"
        :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
        dark fab fixed
        color="accent"
        @click.native="prepareCreate()">
        <v-icon>add</v-icon>
      </v-btn>

    </v-tabs-items>

    <!-- 2. head create/edit dialog -->
    <v-dialog v-model="dlgHead" max-width="500px">
      <v-form ref="lForm" @submit.prevent="tab === 'tab-0' ? saveChanges(lAction) : saveChanges('update-op-bal')">
        <v-card flat>
          <v-card-title v-if="tab === 'tab-1'" class="title">
            {{lHead.gl_acc_name + ' (' + lHead.gl_acc_type + ')'}}
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap v-if="tab === 'tab-0'">
                <v-flex xs12>
                  <v-text-field
                  v-model="lHead.gl_acc_name"
                  label="Head Name"
                  :rules="[rules.required]"
                  maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs5>
                  <v-select
                  v-model="lHead.gl_acc_type"
                  label="Type"
                  :items= "['ASSET', 'LIABILITY', 'INCOME', 'EXPENSE']"
                  :rules="[rules.required]"
                  ></v-select>
                </v-flex>
                <v-flex xs7 v-if="lHead.gl_acc_type === 'ASSET' || lHead.gl_acc_type === 'LIABILITY'">
                  <v-combobox
                  v-model="lHead.gl_acc_class"
                  label="Class (choose/enter new)"
                  :items= "hclass[lHead.gl_acc_type]"
                  :rules="[rules.required]"
                  ></v-combobox>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs6>
                  <v-select
                  v-model="lHead.bal_trans_type"
                  :items="['Debit', 'Credit']"
                  :hint="lHead.gl_acc_type === 'PERSONAL' ? (lHead.bal_trans_type === 'Debit' ? 'i.e due from this person' : 'i.e you owe to this person') : ''"
                  persistent-hint
                  @input="$forceUpdate()"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lHead.bal_amount"
                  type="number"
                  :label="config.CURRENCY"
                  :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="lHead.gl_acc_type === 'PERSONAL'">
                  <v-alert outline value="true" color="info">
                    <span v-if="lHead.bal_trans_type === 'Debit'">
                      Don't forget to <strong>credit</strong> corresponding income heads for this due amount to balance the total amount. Ignore if already done.
                    </span>
                    <span v-else>
                      Don't forget to <strong>debit</strong> corresponding bank/cash heads for this excess/surplus amount to balance the total amount. Ignore if already done.
                    </span>
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="cancelChanges">Cancel</v-btn>
            <v-btn v-if="tab === 'tab-0' && lAction === 'update'" flat @click.native="deleteHead">Delete</v-btn>
            <v-btn :disabled="beingSaved" type="submit" color="accent" flat>Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- snack bar for reporting -->
    <v-snackbar :color="sbarCol" v-model="sbar"
    :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
  </v-snackbar>

  <div v-if="load" style="position:absolute; top:20%; left:50%">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>

</v-flex>
</v-layout>
</v-container>
</div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      // common
      lAction: '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      load: false,
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      // component specific
      tab: 'tab-0',
      tabitems: ['heads', 'opening balance'],
      lHead: '',
      heads: {},
      types: [],
      hclass: {},
      headHead: [
        { text: 'Name', value: 'gl_acc_name' },
        { text: 'Default', value: 'is_system_acc', width: '100px' }
      ],
      dlgHead: false,
      balHead: [
        { text: 'Name', value: 'gl_acc_name' },
        { text: 'Debit', value: 'opening_debit', width: '100px', align: 'right' },
        { text: 'Credit', value: 'opening_credit', width: '100px', align: 'right' }
      ],
      period: null,
      periods: [],
      preType: '',
      totDebit: 0,
      totCredit: 0,
      filterBal: false,
      incomeHeads: [],
      expHeads: []
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    }
  },
  created () {
    // load account head types and list
    this.loadHeads()
    this.loadIncomeExpHeads()
  },
  mounted () {
    this.loading()
    this.lAction = 'view'
  },
  methods: {
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    loading () {
      this.load = true
      setTimeout(() => {
        this.load = false
      }, 500)
    },
    getEmptyHead () {
      var emptyHead = {
        comm_id: config.COMM_ID,
        gl_acc_name: '',
        gl_acc_type: '',
        gl_acc_class: null,
        opening_debit: null,
        opening_credit: null,
        is_system_acc: false
      }
      return emptyHead
    },
    cancelChanges () {
      this.dlgHead = false
      this.lAction = 'view'
      this.lHead = ''
    },
    deleteHead () {
      // confirm
      if (confirm('Sure, you want to delete the head "' + this.lHead.gl_acc_name + '"?')) {
        // delete
        this.saveChanges('delete')
      }
    },
    prepareCreate () {
      this.lHead = this.getEmptyHead()
      this.dlgHead = true
      this.lAction = 'create'
    },
    prepareUpdate (curHead) {
      this.lHead = Object.assign({}, curHead) // keep the original object safely before changes
      this.preType = curHead.gl_acc_type
      this.dlgHead = true
      this.lAction = 'update'
    },
    prepareUpdateBal (curHead) {
      this.lHead = Object.assign({}, curHead) // keep the original object safely before changes
      this.lHead.bal_trans_type = (this.lHead.opening_debit > 0 ? 'Debit' : (this.lHead.opening_credit > 0 ? 'Credit' : (this.lHead.gl_acc_type === 'ASSET' || this.lHead.gl_acc_type === 'EXPENSE' || this.lHead.gl_acc_type === 'PERSONAL') ? 'Debit' : 'Credit'))
      this.lHead.bal_amount = this.lHead.opening_debit > 0 ? this.lHead.opening_debit : this.lHead.opening_credit
      this.dlgHead = true
      this.lAction = 'update'
    },
    saveChanges (action) {
      // validate and save Changes
      if (action === 'create' || action === 'update' || action === 'update-op-bal') {
        if (!this.$refs.lForm.validate()) {
          return
        }
      }
      this.beingSaved = true
      // pre-req
      if (action === 'update-op-bal') {
        if (this.lHead.bal_trans_type === 'Debit') {
          this.lHead.opening_debit = this.lHead.bal_amount
          this.lHead.opening_credit = 0
        } else {
          this.lHead.opening_debit = 0
          this.lHead.opening_credit = this.lHead.bal_amount
        }
      }
      // set agr account if the account being updated is personal account
      if (this.lHead.gl_acc_type === 'PERSONAL') {
        if (this.lHead.bal_trans_type === 'Debit') {
          this.lHead.agr_gl_acc_id = this.expHeads.find(rec => rec.gl_acc_name === 'Accounts Receivable - Members').gl_acc_id
        } else {
          this.lHead.agr_gl_acc_id = this.incomeHeads.find(rec => rec.gl_acc_name === 'Accounts Payable').gl_acc_id
        }
      }
      setTimeout(() => {
        this.axios.post(config.API_URL + '/head/' + action, this.lHead)
        .then(response => {
          // refresh list in front end
          this.loadHeads()
          this.loading()
          this.dlgHead = false
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data, true)
          this.beingSaved = false
        })
      }, 1000)
    },
    loadHeads () {
      // load current finance year by default
      if (!this.period) {
        // derive current period
        var year = (new Date()).getFullYear()
        var month = (new Date()).getMonth()
        if (month > 2) {
          this.maintFrom = '01 Apr ' + year
          this.maintTo = '31 Mar ' + (Number(year) + 1)
        } else {
          this.maintFrom = '01 Apr ' + (Number(year) - 1)
          this.maintTo = '31 Mar ' + year
        }
        // set current year as default one
        this.period = this.maintFrom + ' - ' + this.maintTo
      } else {
        this.maintFrom = this.period.substring(0, this.period.indexOf(' - '))
        this.maintTo = this.period.substring(this.period.indexOf(' - ') + 3)
      }

      // load list of head types
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getAccountTypeByCommId/', qry)
      .then(response => {
        this.types = response.data.map(rec => rec.gl_acc_type)
        var qry = {
          params: {
            trans_dt_from: handy.formatDBDate(this.maintFrom),
            trans_dt_to: handy.formatDBDate(this.maintTo),
            comm_id: config.COMM_ID
          }
        }
        // load heads under each type
        this.axios.get(config.API_URL + '/getAccountHeadsByCommId/', qry)
        .then(response => {
          this.types.forEach(hType => {
            this.heads[hType] = response.data.filter(rec => rec.gl_acc_type === hType)
            // head classifications
            // default
            this.hclass[hType] = []
            if (hType === 'ASSET') {
              this.hclass[hType] = ['Fixed Assets', 'Investments', 'Banks', 'Current Assets']
            } else if (hType === 'LIABILITY') {
              this.hclass[hType] = ['Capital', 'Long-term Liabilities', 'Current Liabilities']
            }
            // available
            this.hclass[hType] = handy.unique(this.hclass[hType].concat(this.heads[hType].filter(rec => rec.gl_acc_class).map(rec => rec.gl_acc_class)))
          })
          // total debit and credit
          this.refreshAmount()
        })
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })

      // load other financial periods if available
      this.axios.get(config.API_URL + '/getAvailableFinPeriodByCommId/', qry)
      .then(response => {
        if (response.data.length) {
          var availYears = handy.unique(response.data.map(rec => (new Date(rec.avail_dates)).getFullYear()))
          availYears.forEach(rec => {
            this.periods.push('01 Apr ' + rec + ' - ' + '31 Mar ' + (rec + 1))
          })
        } else { // default period
          this.periods.push(this.period)
        }
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadIncomeExpHeads () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getIncomeExpensesHeadsByCommId/', qry)
      .then(response => {
        this.incomeHeads = response.data.filter(rec => rec.gl_acc_type === 'INCOME' || rec.gl_acc_type === 'LIABILITY' || rec.gl_acc_type === 'PERSONAL')
        this.expHeads = response.data.filter(rec => rec.gl_acc_type === 'EXPENSE' || rec.gl_acc_type === 'ASSET' || rec.gl_acc_type === 'PERSONAL')
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.incomeHeads = []
        this.expHeads = []
      })
    },
    refreshAmount () {
      this.totDebit = 0
      this.totCredit = 0
      this.types.forEach(hType => {
        this.totDebit += this.heads[hType].map(rec => rec.opening_debit).reduce((a, b) => Number(a) + Number(b), 0)
        this.totCredit += this.heads[hType].map(rec => rec.opening_credit).reduce((a, b) => Number(a) + Number(b), 0)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Heads.vue?8a485a26